import React, { memo } from 'react'

import { SectionItem } from '../sectionItem'

import styles from './myEducation.module.scss'

function MyEducation() {
  return (
    <SectionItem topic="Education">
      <div className={styles.education__wrapper}>
        <div className={styles.education__degree}>
          Bachelor of Engineering (B.Eng.) -- Computer Engineering
        </div>
        <div className={styles.education__uni}>THAI-NICHI INSTITUDE OF TECHNOLOGY</div>
        <div className={styles.education__period}>2014 - 2017</div>
      </div>
    </SectionItem>
  )
}

export default memo(MyEducation)
